import { FC, memo } from 'react';

import { getFloatNumberRoundValue } from '@utils_iqfu/getFloatNumberRoundValue';

import { SalesStatsData } from '@type-def_iqfu/public/MarketData';

import { PublicPropertyType } from '@constants_iqfu';

import styles from '../trend_card_common.module.scss';

type Props = {
  displayData: SalesStatsData;
  areaName: string;
  propertyType: keyof typeof PublicPropertyType;
};

const AverageSalePricePerSquare: FC<Props> = memo(({ displayData, areaName, propertyType }) => {
  const currentValue = displayData.average_sale_price_per_square.current.value;
  const previousValue = displayData.average_sale_price_per_square.previous.value;

  if (!currentValue || !previousValue) return <></>;

  const comparedDifference = (): { sign: 'up' | 'down'; number: number } => {
    const diff = currentValue / previousValue;

    if (diff > 1) {
      return {
        sign: 'up',
        number: getFloatNumberRoundValue((diff - 1) * 100, 1),
      };
    } else {
      return {
        sign: 'down',
        number: getFloatNumberRoundValue((1 - diff) * 100, 1),
      };
    }
  };

  return (
    <>
      {displayData.average_sale_price_per_square.current.year ? (
        <div className={styles.container}>
          <div className={styles.trend_title}>
            {propertyType === 'house' || propertyType === 'land'
              ? displayData.average_sale_price_per_square.current.year + '年の'
              : ''}
            {PublicPropertyType[propertyType]}売却価格相場
            <br />（{areaName}）
          </div>

          <div className={styles.value_container}>
            <div className={styles.trend_value}>
              <p>{displayData.average_sale_price_per_square.previous.year}年</p>

              <span className={styles.value}>{getFloatNumberRoundValue(previousValue, 1)}</span>
              <span className={styles.unit_label}>万/m2</span>
            </div>
            {comparedDifference().number ? (
              <div className={styles.compare_label}>
                <div className={styles.compare_label_inner}>
                  <span className={styles.compare_label_number}>{comparedDifference().number}</span>%
                  <br />
                  {comparedDifference().sign === 'up' ? 'UP' : 'DOWN'}
                </div>
              </div>
            ) : (
              <div className={styles.compare_arrow}></div>
            )}
            <div className={styles.trend_value}>
              <p>{displayData.average_sale_price_per_square.current.year}年</p>
              <span className={styles.value}>{getFloatNumberRoundValue(currentValue, 1)}</span>
              <span className={styles.unit_label}>万/m2</span>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
});

AverageSalePricePerSquare.displayName = 'AverageSalePricePerSquare';

export default AverageSalePricePerSquare;
